import { computed } from 'vue'

/** Glamora product-feed stub — no church overlays. Keeps AppShell + ProductOverlays compiling. */
export function useProductFeed() {
  return {
    query: { data: computed(() => null) },
    showTerms: computed(() => false),
    announcements: computed(() => []),
    latestRelease: computed(() => null),
    tourDone: computed(() => true),
    newTags: computed(() => []),
    tenant: computed(() => null),
    acceptTerms: async () => {},
    completeTour: async () => {},
    restartTour: async () => {},
    isNewFeature: (_featureKey?: string) => false,
  }
}

/** No-op tour helpers — tours are not part of the Glamora SPA MVP. */
export function getTourSteps() {
  return []
}

export function highlightTourTarget(_selector: string) {
  // no-op
}
